import { Component, inject } from '@angular/core';
import { CropperAspectRatio, CropperDialogData, CropperDialogResult } from '../../interfaces/cropper-dialog.interface';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';

@Component({
    selector: 'app-cropper-dialog',
    templateUrl: './cropper-dialog.component.html',
    styleUrls: ['./cropper-dialog.component.scss']
})
export class CropperDialogComponent {
  public data: CropperDialogData = inject(MAT_DIALOG_DATA);
  protected dialogRef:MatDialogRef<CropperDialogComponent> = inject(MatDialogRef);

  public result: CropperDialogResult | undefined = undefined;
  
  private readonly defaultOrientation = this.data.defaultOrientation;
  
  /** true: Horizontal | false: Vertical */
  public orientation:boolean = this.defaultOrientation;
  
  public aspectRatioConf: CropperAspectRatio[] = this.data.ratios;
  public selectedAspectRatio = this.aspectRatioConf[0];

  public canvasRotation = 0;
  private translateH = 0;
  private translateV = 0;
  private scale: number = 1;

  public containWithinAspectRatio: boolean = false;
  public transform: ImageTransform = { translateUnit: 'px' };
  public loading: boolean = false;
  public submitLoading: boolean = false;

  public submit() {
    return this.dialogRef.close(this.result);
  }

  public imageCropped(event: ImageCroppedEvent) {
    const {blob, objectUrl} = event;
    if(blob && objectUrl) {
      this.result = { blob, imageUrl: objectUrl }
    }
  }

  get aspectRatio() {
    return this.orientation ? this.selectedAspectRatio.sizeH : this.selectedAspectRatio.sizeV;
  }

  rotateLeft() {
    this.loading = true;
    setTimeout(() => {
      this.canvasRotation--;
      this.flipAfterRotate();
    });
  }


  rotateRight() {
    this.loading = true;
    setTimeout(() => {
      this.canvasRotation++;
      this.flipAfterRotate();
    });
  }

  moveRight() {
    this.transform = { ...this.transform, translateH: ++this.translateH };
  }

  moveLeft() {
    this.transform = { ...this.transform, translateH: --this.translateH };
  }

  moveBottom() {
    this.transform = { ...this.transform, translateV: ++this.translateV };
  }

  moveTop() {
    this.transform = { ...this.transform, translateV: --this.translateV };
  }

  private flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = { ...this.transform, flipH: flippedV, flipV: flippedH };
    this.translateH = 0;
    this.translateV = 0;
    this.loading = false;
  }

  flipHorizontal() {
    this.transform = { ...this.transform, flipH: !this.transform.flipH };
  }

  flipVertical() {
    this.transform = { ...this.transform, flipV: !this.transform.flipV };
  }

  resetImage() {
    this.scale = 1;
    this.canvasRotation = 0;
    this.transform = { translateUnit: 'px' };
  }

  zoomOut() {
    this.scale -= .025;
    this.scale = Math.max(this.scale, 0.3)
    this.transform = { ...this.transform, scale: this.scale };
  }

  disableZoomOut() {
    return this.scale <= 0.4;
  }

  zoomIn() {
    this.scale += .025;
    this.transform = { ...this.transform, scale: this.scale };
  }

  toggleContainWithinAspectRatio() {
    this.containWithinAspectRatio = !this.containWithinAspectRatio;
  }

  toggleOrientation() {
    this.orientation = !this.orientation;
  }

  toggleAspectRatio(label: string) {
    this.selectedAspectRatio = this.aspectRatioConf.find(r => r.label == label)!;
  }
}
